import { useTheme } from '@mui/material';

export const TryAgainIcon = () => {
    const theme = useTheme();
    const { stroke } = theme.colors.other.icon;

    return (
        <svg width={49} height={48} fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M37 20C37.55 20 38 19.55 38 19V11C38 10.45 37.55 10 37 10C36.45 10 36 10.45 36 11V16.7875C33.55 12.7188 29.0938 10 24 10C16.2688 10 10 16.2688 10 24C10 31.7313 16.2688 38 24 38C28.9937 38 33.375 35.3875 35.8563 31.45C36.2688 30.8 35.7687 30 35 30C34.625 30 34.2875 30.2 34.0812 30.5125C31.9437 33.8125 28.225 36 24 36C17.375 36 12 30.625 12 24C12 17.375 17.375 12 24 12C28.4438 12 32.3187 14.4125 34.3937 18H29C28.45 18 28 18.45 28 19C28 19.55 28.45 20 29 20H37Z"
                fill={stroke.primary}
            />
        </svg>
    );
};
